// extracted by mini-css-extract-plugin
export default {"subtitleContainer":"SubtitleContainer-module__subtitleContainer__kpil2","subtitleContainerMobile":"SubtitleContainer-module__subtitleContainerMobile__HtKXc"};